// extracted by mini-css-extract-plugin
var _1 = "44px";
var _2 = "6.8";
var _3 = "#4c4c4c";
var _4 = "spinner_circle__60lss";
var _5 = "spinner_circledash__sfh4h";
var _6 = "#057676";
var _7 = "#434343";
var _8 = "spinner_spinner__h2hdd";
var _9 = "teal";
var _a = "spinner_wrapper__ri7xi";
var _b = "spinner_wrapperrotate__jyyni";
export { _1 as "baseSize", _2 as "baseThickness", _3 as "body", _4 as "circle", _5 as "circleDash", _6 as "darkTeal", _7 as "headline", _8 as "spinner", _9 as "teal", _a as "wrapper", _b as "wrapperRotate" }
